module.exports = __webpack_public_path__ + "img/backArrow.aa6cb847.svg";